import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { CASINO_TYPE_LOBBY } from '@/config/casino'
import type { CasinoGame, CasinoTypeId } from '@/types/casino'
import type { RootState } from '@/store/store'

interface CasinoState {
	selectedTypeId: CasinoTypeId | null
	favoriteIds: string[]
	playGame: CasinoGame | null
}

const initialState: CasinoState = {
	selectedTypeId: CASINO_TYPE_LOBBY,
	favoriteIds: [],
	playGame: null,
}

const casinoSlice = createSlice({
	name: 'casino',
	initialState,
	reducers: {
		setSelectedCasinoType(state, action: PayloadAction<CasinoTypeId>) {
			state.selectedTypeId = action.payload
		},
		clearSelectedCasinoType(state) {
			state.selectedTypeId = null
		},
		toggleCasinoFavorite(state, action: PayloadAction<string>) {
			const gameId = action.payload
			const index = state.favoriteIds.indexOf(gameId)

			if (index >= 0) {
				state.favoriteIds.splice(index, 1)
				return
			}

			state.favoriteIds.push(gameId)
		},
		setPlayGame(state, action: PayloadAction<CasinoGame>) {
			state.playGame = action.payload
		},
		clearPlayGame(state) {
			state.playGame = null
		},
	},
})

export const { setSelectedCasinoType, clearSelectedCasinoType, toggleCasinoFavorite, setPlayGame, clearPlayGame } = casinoSlice.actions

export const selectSelectedCasinoTypeId = (state: RootState) => state.casino.selectedTypeId

export const selectCasinoFavoriteIds = (state: RootState) => state.casino.favoriteIds

export const selectIsCasinoFavorite = (gameId: string) => (state: RootState) => state.casino.favoriteIds.includes(gameId)

export const selectPlayGame = (state: RootState) => state.casino.playGame

export default casinoSlice.reducer
